<template>
<div class="fixed top-0 w-full max-w-5xl z-20">
    <div class="flex divide-x md:border-x border-b shadow lg:rounded-b-lg transition-all duration-300
                bg-skin-b-list-back
                border-skin-b-list-bord"
        :class="[
            headercolor=='default' ? 'text-skin-b-list-base bg-skin-b-list-back' : '',
            headercolor=='green' ? 'bg-green-100 dark:bg-green-700 text-green-800 dark:text-green-100' : '',
            headercolor=='red' ? 'bg-red-100 dark:bg-red-700 text-red-800 dark:text-red-100' : '',
          ]">        
        <div class="flex-none inline-flex">
            <router-link :to="target" custom v-slot="{ navigate }">
                <button type="button" @click="navigate" role="link"
                class="px-2 sm:px-4 lg:rounded-bl-lg
                        focus:z-10 focus:ring-0 focus:ring-transparent"
                :class="[
                headercolor=='default' ? 'hover:text-skin-b-base hover:bg-skin-b-list-head' : '',
                headercolor=='green' ? 'hover:text-green-700 dark:hover:text-green-50 hover:bg-green-50 dark:hover:bg-green-600' : '',
                headercolor=='red' ? 'hover:text-red-700 dark:hover:text-red-50 hover:bg-red-50 dark:hover:bg-red-600' : '',
                ]">
                    <IconArrowLeft class="w-8 h-8"/>
                </button>
            </router-link>
        </div>
        <div class="inline-flex grow truncate">
            <div class="my-auto pl-4 hidden sm:inline-block"
                :class="[
                    headercolor=='default' ? 'text-skin-b-list-mute' : '',
                    headercolor=='green' ? 'text-green-800 dark:text-green-100' : '',
                    headercolor=='red' ? 'text-red-800 dark:text-red-100' : '',
                ]">
                <slot name="icon"></slot>     
            </div> 
    
            <div class="p-3 sm:p-4 w-full my-auto truncate">
                <h1 class="font-bold transition-all duration-300 ease-in-out truncate"
                :class="[
                        isShrunk ? 'text-lg sm:text-xl' : 'text-xl sm:text-2xl'
                        ]"
                >
                    <span>{{ title }}</span>
                    <span v-if="titleadd"> {{ titleadd }}</span>
                </h1>
                <h4 v-if="hassubline" class="font-medium text-base sm:text-lg text-skin-b-list-mute truncate">
                    <slot name="subline"></slot>
                </h4>
                <div v-if="hasmenu" class="w-full">
                    <slot name="menu"></slot>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import IconArrowLeft from '../icons/IconArrowLeft.vue'

export default {
    components: {
        IconArrowLeft,
    },
    props: {
        headercolor: {
        type: String,
        default: 'default'
      },
        title: String,
        titleadd: {
        type: String,
        default: ''
      },
        target: String,
        hassubline: Boolean,
        hasmenu: Boolean,
        isShrunk: Boolean,
    },
  };
</script>
<style scoped>
</style>
    